// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"5084dd290cc7465cc160","9249":"9bf85955d11a98583068"}[chunkId] + ".chunk.js";
};